module.exports = __webpack_public_path__ + "static/noticias-11-ab3ea3040b14e53211585ae7a5d9f579.jpg";